var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"issue-chart"},[(!_vm.isEmpty)?[_c('div',{key:"charts",ref:"charts"})]:_c('div',{key:"notData",staticClass:"notData"},[_c('img',{attrs:{"src":require("../../../../assets/image/issue/defalutRound.png")}}),_c('div',{staticClass:"notData-word"},[_vm._v("暂无数据")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }